export default __webpack_public_path__ + "static/media/menu.2b36ec93.svg";